import { cmsCLient } from '@/services/axiosConfig'
import { GetAboutusInfoRes } from './types'

export type GetAboutusInfo = () => Promise<GetAboutusInfoRes>

export const getAboutusInfo: GetAboutusInfo = async () => {
  try {
    const response = await cmsCLient.get('/contents/about-us', { headers: { "Authorization": "Bearer " + 'a3912f42841d1efe1938a6794137bd82521a887521171b5d8bcfcd431f66bbf57b3cfb22f18f1fe4068dbc68f8ef8296b305ab3adf054c0d509e2a48e83a9fa73124de91a32e9d2375392be3aa28bb5adc6c4f56bd7895a3aeac2501bd168ef6eeec82399c90a712fc78587521aa72cd0dadd73c27938eca4908e46fef557d97' }})
    return response.data
  } catch (e: any) {
    return e.message
  }
}
